import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import { Building, Building2 } from "lucide-react";
import { useUserId } from "../../UserIdContext";

const InicioGeneralGestion = () => {
  const navigate = useNavigate();
  const { setDeposito } = useUserId();

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const seleccionarBinder = (deposito) => {
    setDeposito(deposito);
    const queryBinder = deposito === "binder1" ? "1" : "2";
    navigate(`/inicio?binder=${queryBinder}`);
  };

  const irBinder1 = () => seleccionarBinder("binder1");
  const irBinder2 = () => seleccionarBinder("binder2");
  const volver = () => navigate("/iniciogeneral");
  const salir = () => navigate("/");

  return (
    <div className="login-container-binderx">
      <div className="container binderx-max text-center">
        <div className="mb-4 logo-wrap" data-aos="fade-down">
          <img src="/logobinder.png" alt="BinderX Logo" className="binderx-logo" />
        </div>

        <div className="mb-2" data-aos="fade-down" data-aos-delay="50">
          <h1 className="binderx-title text-light fw-bold mb-1">Selecciona</h1>
          <p className="text-muted mb-0" style={{ fontSize: 15 }}>
            {"Elige el binder para Sistema de Gesti\u00f3n Dep\u00f3sitos Nacionales"}
          </p>
        </div>

        <div
          className="row row-cols-1 row-cols-md-2 g-4 justify-content-center align-items-stretch mt-1 binderx-card-grid"
          data-aos="zoom-in"
          data-aos-delay="100"
        >
          <div className="col d-flex card-col-binderx">
            <div
              className="card login-card-binderx glow-hover h-100 w-100 mx-auto clickable-card"
              onClick={irBinder1}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && irBinder1()}
            >
              <div className="card-body d-flex flex-column justify-content-center align-items-center gap-4 p-4 text-center">
                <div className="icon-badge mb-3">
                  <Building2 size={36} />
                </div>
                <h3 className="card-title-binderx text-light mb-4">Binder 1</h3>
                <span className="card-hint">Ingresar</span>
              </div>
            </div>
          </div>

          <div className="col d-flex card-col-binderx" data-aos="zoom-in" data-aos-delay="180">
            <div
              className="card login-card-binderx glow-hover h-100 w-100 mx-auto clickable-card"
              onClick={irBinder2}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && irBinder2()}
            >
              <div className="card-body d-flex flex-column justify-content-center align-items-center gap-4 p-4 text-center">
                <div className="icon-badge mb-3">
                  <Building size={36} />
                </div>
                <h3 className="card-title-binderx text-light mb-4">Binder 2</h3>
                <span className="card-hint">Ingresar</span>
              </div>
            </div>
          </div>
        </div>

        <div
          className="mt-4 d-flex flex-column flex-md-row gap-3 justify-content-center action-row-binderx"
          data-aos="fade-up"
          data-aos-delay="240"
        >
          <button
            className="btn btn-outline-light fw-bold py-2 px-4 rounded-pill w-100 w-md-auto"
            onClick={volver}
          >
            Volver
          </button>
          <button
            className="btn btn-outline-success fw-bold py-2 px-4 rounded-pill w-100 w-md-auto"
            onClick={salir}
          >
            Salir
          </button>
        </div>

        <div className="mt-3 footer-note-binderx" data-aos="fade-up" data-aos-delay="260">
          <small className="text-muted">BinderX · Seleccion de Sistema de gestion Dep&oacute;sitos nacionales</small>
        </div>
      </div>

      <style>{`
        .login-container-binderx {
          width: 100%;
          min-height: 100vh;
          min-height: 100dvh;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          background: linear-gradient(135deg, #0c1f1d 0%, #0f2a25 40%, #183c34 100%);
          padding: 20px 20px 28px;
          overflow-y: auto;
        }

        .binderx-max {
          width: 100%;
          max-width: 980px;
          margin-left: auto;
          margin-right: auto;
        }
        .card-col-binderx {
          max-width: 540px;
        }

        .binderx-title {
          font-size: clamp(1.8rem, 3vw, 2.4rem);
          text-align: center;
        }

        .logo-wrap {
          display: flex;
          justify-content: center;
        }

        .binderx-logo {
          width: clamp(400px, 54vw, 660px);
          max-width: 98vw;
          display: block;
          transform: translateX(14px);
          filter: drop-shadow(0 6px 10px rgba(0, 255, 170, 0.12));
          transition: transform .25s ease, filter .25s ease;
        }
        .binderx-logo:hover {
          transform: translateX(14px) translateY(-2px) scale(1.01);
          filter: drop-shadow(0 8px 16px rgba(0, 255, 170, 0.2));
        }

        .login-card-binderx {
          background: transparent;
          border: none;
          border-radius: 34px;
          box-shadow: none;
          overflow: visible;
          transition: transform .25s ease;
        }
        .login-card-binderx .card-body {
          min-height: 300px;
          margin: 0;
          padding: 2.2rem 2rem !important;
          border: 2px solid #33cc99;
          border-radius: 34px;
          background: linear-gradient(180deg, #112d28 0%, #0f2723 100%);
          box-shadow: 0 0 0 1px rgba(51, 204, 153, 0.22), 0 16px 34px rgba(0, 255, 170, 0.14);
        }
        .glow-hover:hover {
          transform: translateY(-2px);
        }
        .glow-hover:hover .card-body {
          border-color: #66ffd1;
          box-shadow: 0 0 0 1px rgba(102, 255, 209, 0.35), 0 0 16px rgba(0, 255, 170, 0.22), 0 18px 40px rgba(0, 255, 170, 0.2);
        }
        .clickable-card { cursor: pointer; }
        .clickable-card:focus-visible {
          outline: 2px solid #66ffd1;
          outline-offset: 3px;
        }
        .card-title-binderx {
          max-width: 360px;
          margin-left: auto;
          margin-right: auto;
          font-size: clamp(1.5rem, 2.55vw, 2.05rem);
          font-weight: 700;
          line-height: 1.15;
          text-align: center;
          text-wrap: balance;
        }
        .card-hint {
          display: inline-block;
          margin: 0;
          padding: 0;
          border: none;
          background: transparent;
          color: rgba(223, 247, 238, 0.9);
          font-size: 1rem;
          font-weight: 600;
          letter-spacing: 0.1px;
          line-height: 1.2;
          box-shadow: none;
          transition: none;
        }

        .icon-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 64px;
          height: 64px;
          border-radius: 50%;
          background: radial-gradient(110px 110px at 50% 50%, rgba(0,255,170,0.12), rgba(0,255,170,0.04) 60%, transparent 61%);
          color: #bfffe8;
          border: 1px solid rgba(51, 204, 153, 0.45);
          box-shadow: inset 0 0 12px rgba(0, 255, 170, 0.08), 0 6px 14px rgba(0, 0, 0, 0.25);
        }

        .btn-outline-success {
          border: 1px solid #33cc99;
          color: #dff7ee;
          background-color: transparent;
          border-radius: 999px;
        }
        .btn-outline-success:hover {
          background-color: #1b3b34;
          color: #ffffff;
          border-color: #33cc99;
          box-shadow: 0 0 8px rgba(0, 255, 170, 0.22);
        }
        .btn-outline-light {
          border: 1px solid rgba(255,255,255,0.4);
          color: #f7fffb;
          background-color: transparent;
          border-radius: 999px;
        }
        .btn-outline-light:hover {
          background-color: rgba(255,255,255,0.08);
          color: #ffffff;
          border-color: rgba(255,255,255,0.7);
          box-shadow: 0 0 8px rgba(255,255,255,0.25);
        }

        @media (min-width: 768px) {
          .w-md-auto { width: auto !important; }
        }

        @media (min-height: 860px) {
          .login-container-binderx {
            align-items: center;
          }
        }

        @media (max-height: 820px) and (min-width: 768px) {
          .login-container-binderx {
            padding-top: 16px;
            padding-bottom: 18px;
          }
          .logo-wrap {
            margin-bottom: 1rem !important;
          }
          .binderx-logo {
            width: clamp(260px, 30vw, 390px);
            transform: translateX(10px);
          }
          .binderx-logo:hover {
            transform: translateX(10px) translateY(-2px) scale(1.01);
          }
          .binderx-card-grid {
            --bs-gutter-x: 1.25rem;
            --bs-gutter-y: 1.25rem;
          }
          .login-card-binderx .card-body {
            min-height: 220px;
            padding: 1.5rem 1.35rem !important;
          }
          .icon-badge {
            width: 58px;
            height: 58px;
          }
          .card-title-binderx {
            font-size: clamp(1.3rem, 2vw, 1.8rem);
            margin-bottom: 1rem !important;
          }
          .action-row-binderx {
            margin-top: 1rem !important;
            gap: 0.75rem !important;
          }
          .footer-note-binderx {
            margin-top: 0.75rem !important;
          }
        }

        @media (max-width: 767px) {
          .binderx-logo {
            transform: translateX(8px);
          }
          .binderx-logo:hover {
            transform: translateX(8px) translateY(-2px) scale(1.01);
          }
          .login-card-binderx {
            border-radius: 24px;
          }
          .login-card-binderx .card-body {
            min-height: 240px;
            padding: 1.8rem 1.5rem !important;
            border-radius: 24px;
          }
        }

        html, body { height: 100%; margin: 0; padding: 0; background: transparent; }
      `}</style>
    </div>
  );
};

export default InicioGeneralGestion;
